
import { defineComponent } from 'vue';
import {
  ButtonID, tableRef, playerTurn, 
} from './PopBoard.vue';

// IMPORTANT: All of this can't be replaced by :hover, because it'll mess
// stuff up once the button's clicked(not supposed to change color)

enum ButtonState {INACTIVE, HOVER}
const COLOR_HOVER = '#f87171';
const COLOR_INACTIVE = '#fca5a5';
const COLOR_ACTIVE = '#e53e3e';

const SIZE_NORMAL = '1';
const SIZE_CLICKED = '1.03';

export const TEXT_PLAYER_ONE = '#3BC0FF';
export const TEXT_PLAYER_TWO = '#F5F5F5';

const __default__ = defineComponent({
  name: 'PopButton',
  props: {
    buttonID: {
      type: Object as () => ButtonID,
      required: true,
    },
    buttonState: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ButtonState: Object.freeze(ButtonState), // pass the enum thing(kinda a hack)

      currState: ButtonState.INACTIVE as ButtonState,
      textStyleObject: {
        color: TEXT_PLAYER_ONE,
      },
      displayTooltip: 'none',
      finalizedPlayerTurn: -1,
    };
  },
  methods: {
    getClickable() : boolean {
      return (tableRef.value.currActiveRow === -1 || tableRef.value.currActiveRow === this.buttonID.rowID);
    },
    changeState(state : ButtonState) {
      this.currState = state;

      if (!this.getClickable()
      && this.currState === ButtonState.HOVER
      && !this.buttonState) {
        this.displayTooltip = 'block';
      } else {
        this.displayTooltip = 'none';
      }
    },
    onClick() {
      if (tableRef.value.setActiveRow(this.buttonID.rowID)) {
        tableRef.value.clickButton(this.buttonID, playerTurn.value);
        this.finalizedPlayerTurn = playerTurn.value;
        this.textStyleObject.color = (this.finalizedPlayerTurn === 1) ? TEXT_PLAYER_ONE : TEXT_PLAYER_TWO;
      } else {
        this.changeState(ButtonState.HOVER);
      }
    },
  },
  computed: {
    computedColor() : string {
      if (this.buttonState) {
        return COLOR_ACTIVE;
      }
      if (this.currState === ButtonState.HOVER && this.getClickable()) {
        return COLOR_HOVER;
      }
      return COLOR_INACTIVE;
    },
    computedSize() : string {
      if (this.buttonState) {
        return SIZE_CLICKED;
      }
      return SIZE_NORMAL;
    },
    pressedPlayerTxt() : string {
      return this.buttonState ? this.finalizedPlayerTurn.toString() : '';
    },
  },
});


import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "bc29bac2": (_ctx.displayTooltip)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__